/* import __COLOCATED_TEMPLATE__ from './search-button.hbs'; */
/* RESPONSIBLE TEAM: team-help-desk-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    route: string;
    queryParams?: Record<string, unknown>;
  };
}

const SearchButton = templateOnlyComponent<Signature>();
export default SearchButton;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::SearchButton': typeof SearchButton;
    'inbox2/left-nav/search-button': typeof SearchButton;
  }
}
